import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { ro } from '../lang/ro'
import { en } from '../lang/en'
import { hr } from '../lang/hr'
import { bg } from '../lang/bg'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locales: 'ro',
    fallbackLocale: 'ro',
    messages: {
        ro: ro,
        en: en,
        hr: hr,
        bg: bg,
    }
})

export default i18n
